import React from 'react';
import CompsWidgetBuilder from './CompsWidgetBuilder';
import CompsWidgetRenderer from './CompsWidgetRenderer';
import Preview from './Preview';
import type { WidgetDefinition } from '../../../registry';
import type { CompsWidgetConfig } from './types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup } from '@fortawesome/free-solid-svg-icons';

export { default as CompsWidgetRenderer } from './CompsWidgetRenderer';
export * from './types';

export const definition: WidgetDefinition = {
  type: 'comps',
  meta: {
    label: 'Comps',
    icon: React.createElement(FontAwesomeIcon, { icon: faLayerGroup }),
    description: 'Peer-comparison P/E and EV/EBITDA multiples vs the asset',
    isSystem: true,
    isCreatable: true,
    requiresAsset: true,
    dataFlow: 'display',
  },
  dataProvider: {
    widget: 'COMPS',
  },
  defaultSize: { w: 6, h: 5, minW: 4, minH: 4 },
  defaultConfig: () => ({} as CompsWidgetConfig),
  Builder: CompsWidgetBuilder,
  Renderer: CompsWidgetRenderer,
  Preview,
};
